import { createContext } from "react";
import { AllProducts } from "../../server/ServerSchemas";

export const AllProductsContext = createContext<{
  allProducts: AllProducts;
  refresh: () => void;
}>({ allProducts: undefined, refresh: undefined } as any);
